import { Button, Menu } from "antd";
import { BsFilter } from "react-icons/bs";
import { useState } from "react";
import PropTypes from 'prop-types'

const styles = {
  menuItem: (key, currentKey) => ({
    textAlign: "center",
    justifyContent: "center",
    // backgroundColor: currentKey == key && "white",
  }),
  form: () => ({
    backgroundColor: "#ffffff",
  }),
  majorRowDiv: () => ({
    paddingLeft: 32,
    paddingRight: 35,
    paddingTop: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // paddingBottom: 40
  }),
  filterRowDiv: (isLastRow) => ({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: isLastRow && "flex-end",
  }),
  formLabel: () => ({
    color: "#a1a1b5",
    letterSpacing: 1.5,
  }),
  inputSize: () => ({
    width: 250,
  }),
};

const DashboardHeader = ({
  setShowFilter,
  handleChange
}) => {

  const [ currentTab, setCurrentTab ] = useState("0")

  return (
    <div
      style={{
        borderRadius: "20px",
        boxShadow: "0 4px 30px 0 rgba(0, 0, 0, 0.06)",
        backgroundColor: "white",
        margin: "10px 30px 0 30px",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={{ float: "left", fontWeight: "500" }}>
        <Menu
          onClick={(e) => {
            console.log(e.key);
            handleChange(e.key);
            setCurrentTab(e.key);
          }}
          style={{
            display: "flex",
            justifyContent: "space-around",
            backgroundColor: "#00000000",
            marginRight: "10px",
            marginLeft: "10px",
            width: "100%",
          }}
          mode="horizontal"
          selectedKeys={[currentTab]}
        >
          {/* <Menu.Item style={styles.menuItem("Overview", currentTab)} key="overview">
            Overview
          </Menu.Item> */}
          <Menu.Item style={styles.menuItem("0", currentTab)} key="0">
            Mentions Volume
          </Menu.Item>
          <Menu.Item style={styles.menuItem("1", currentTab)} key="1">
            Audience Demographics
          </Menu.Item>
          <Menu.Item style={styles.menuItem("2", currentTab)} key="2">
            Geography
          </Menu.Item>
          <Menu.Item style={styles.menuItem("3", currentTab)} key="3">
            Language
          </Menu.Item>
          <Menu.Item style={styles.menuItem("4", currentTab)} key="4">
            Sentiment Analysis
          </Menu.Item>
        </Menu>
      </div>
      <div
        style={{
          float: "right",
          width: "100%",
          alignItems: "center",
          marginRight: "15px",
        }}
      >
        <span
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            right: 0,
            float: "right",
            height: "100%",
          }}
        >
          <Button
            style={{
              marginLeft: "20px",
            }}
            onClick={() => {
              setShowFilter(true);
            }}
            shape="circle"
            icon={
              <BsFilter
                style={{
                  fontSize: "110%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "6px",
                }}
              />
            }
          ></Button>
        </span>
      </div>
    </div>
  );
};

DashboardHeader.propTypes = {
  setShowFilter: PropTypes.func,
  handleChange: PropTypes.func
}

DashboardHeader.defaultProps = {
  setShowFilter: null,
  handleChange: () => {}
}

export default DashboardHeader;